/**
 * GLSL to visualize UVs using the calibration texture
 * @module
 */

export const uvCalibrationFragmentShader = `
varying vec2 vUv;
uniform sampler2D calibrationTexture;

void main() {
  // World units are in inches, and the calibration texture spans 24in x 24in
  vec2 uv = fract(vUv / 24.0) ;
  gl_FragColor = texture2D( calibrationTexture, uv );
}
`;
